module.exports = __webpack_public_path__ + "img/右边板块标题样式.6124004d.png";